import React, { PropTypes } from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component, auth, redirect, ...rest }) => {
  const PrivateRouteRender = (props) => {
    if (auth) return React.createElement(component, props);
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: { from: props.location },
        }}
      />
    );
  };

  PrivateRouteRender.propTypes = {
    location: PropTypes.string.isRequired,
  };

  return (
    <Route {...rest} render={PrivateRouteRender} />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  auth: PropTypes.shape({
    uid: PropTypes.string,
  }),
  redirect: PropTypes.string,
};

PrivateRoute.defaultProps = {
  auth: null,
  redirect: '/login',
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/routes/private-route.js